import React, { useState, useEffect } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { confirmEmailChange } from '../../../api/productService';
import './ConfirmEmailChange.css';

const ConfirmEmailChange: React.FC = () => {
  const [searchParams] = useSearchParams();
  const [loading, setLoading] = useState(true);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();
  const { t } = useTranslation();

  useEffect(() => {
    const confirmEmail = async () => {
      const token = searchParams.get('token');
      const email = searchParams.get('email');

      if (!token || !email) {
        setError('Invalid confirmation link. Missing token or email.');
        setLoading(false);
        return;
      }

      try {
        await confirmEmailChange(token);
        setSuccess(true);
      } catch (error: any) {
        console.error('Error confirming email change:', error);
        
        const errorMessage = error.response?.data?.error?.message || 
                            error.response?.data?.message || 
                            'Failed to confirm email change. Please try again.';
        
        setError(errorMessage);
      } finally {
        setLoading(false);
      }
    };

    confirmEmail();
  }, [searchParams]);

  const handleGoBack = () => {
    navigate('/profile');
  };

  if (loading) {
    return (
      <div className="confirm-email-change-page">
        <div className="confirm-email-change-content">
          <div className="confirm-email-change-loading">
            <div className="loading-spinner"></div>
            <h2>{t('common.loading')}</h2>
            <p>Confirming your email change...</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="confirm-email-change-page">
      <div className="confirm-email-change-content">
        {success ? (
          <div className="confirm-email-change-success">
            <div className="success-icon">
              <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="32" cy="32" r="32" fill="#10B981" fillOpacity="0.1"/>
                <circle cx="32" cy="32" r="24" fill="#10B981" fillOpacity="0.2"/>
                <path d="M20 32l8 8 16-16" stroke="#10B981" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </div>
            <h2>Email Changed Successfully!</h2>
            <p>Your email address has been updated successfully. You can now use your new email address to log in.</p>
          </div>
        ) : (
          <div className="confirm-email-change-error">
            <div className="error-icon">
              <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="32" cy="32" r="32" fill="#EF4444" fillOpacity="0.1"/>
                <circle cx="32" cy="32" r="24" fill="#EF4444" fillOpacity="0.2"/>
                <path d="M32 20v16M32 44h.01" stroke="#EF4444" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </div>
            <h2>Email Change Failed</h2>
            <p>{error}</p>
          </div>
        )}
      </div>
      
      <div className="confirm-email-change-footer">
        <button 
          className="confirm-email-change-btn"
          onClick={handleGoBack}
        >
          {success ? 'Go to Profile' : 'Try Again'}
        </button>
      </div>
    </div>
  );
};

export default ConfirmEmailChange; 